import { render, staticRenderFns } from "./AddressSelect.vue?vue&type=template&id=749c402e&scoped=true"
import script from "./AddressSelect.vue?vue&type=script&lang=js"
export * from "./AddressSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749c402e",
  null
  
)

export default component.exports